module.exports = __webpack_public_path__ + "static/media/list-white.06598c77.svg";